import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import LoadingOrValue from "@covertree/ui/loading/LoadingOrValue";
import { formatAwsDateString } from "@covertree/utils/time/formatAwsDateString";
import { Resident } from "@graphql/api";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
}
export default function MoveDatesDetails({ isLoading, resident }: Props) {
  return (
    <DisplayPropertiesCard
      properties={[
        {
          label: "Move in Date",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={
                resident?.moveInDate
                  ? formatAwsDateString(resident.moveInDate)
                  : "N/A"
              }
              height={28}
              width={150}
            />
          ),
        },
        ...(resident?.sos
          ? [
              {
                label: "SOS",
                value: (
                  <LoadingOrValue
                    loading={!resident && isLoading}
                    value={resident.sos}
                    height={28}
                    width={150}
                  />
                ),
              },
            ]
          : []),
        {
          label: "Move out Date",
          value: (
            <LoadingOrValue
              loading={!resident && isLoading}
              value={
                resident?.moveOutDate
                  ? formatAwsDateString(resident.moveOutDate)
                  : "N/A"
              }
              height={28}
              width={150}
            />
          ),
        },
      ]}
    />
  );
}
